export const featuredJourneys = [
  {
    slug: "dubai",
    city: "Dubai",
    country: "UAE",
    heroEyebrow: "Discover The Gulf",
    heroTitle: "Dubai.",
    heroDescription:
      "Skyline glamour, late-night waterfront energy, and desert calm wrapped into one polished Flyvora escape.",
    heroImage:
      "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1600&q=80",
    cardNote: "Short-haul luxury from Chennai",
    cardTag: "Featured Journey",
    cardImage:
      "https://images.unsplash.com/photo-1518684079-3c830dcef090?auto=format&fit=crop&w=1200&q=80",
    large: true,
    conciergeTitle: "A city engineered for spectacle, speed, and ease.",
    conciergeBody:
      "Dubai works best when the itinerary balances polished city energy with slower moments: a dawn marina walk, an afternoon skydeck, then dinner above the lights. This journey is for travelers who want high contrast without friction.",
    highlights: [
      {
        key: "why-now",
        title: "Why Visit Now",
        body: "Warm evenings, clear skies, and enough pace to feel electric without tipping into chaos.",
      },
      {
        key: "flyvora",
        title: "Flyvora Angle",
        body: "Best for quick premium breaks, sharp business hops, and travelers who value a smooth premium rhythm.",
      },
    ],
    experiences: [
      {
        title: "Sunrise at Dubai Marina",
        tag: "Waterfront",
        description: "Glass towers, early light, and the quiet version of a city that rarely slows down.",
        image:
          "https://images.unsplash.com/photo-1526495124232-a04e1849168c?auto=format&fit=crop&w=1200&q=80",
        featured: true,
      },
      {
        title: "Old Dubai Souks",
        tag: "Culture",
        description: "Gold, spice, and creek-side routes that give the city a deeper texture.",
        image:
          "https://images.unsplash.com/photo-1578894381163-e72c17f2d45f?auto=format&fit=crop&w=900&q=80",
      },
      {
        title: "Desert Sundowner",
        tag: "Escape",
        description: "A clean reset from the skyline with dunes, amber light, and open space.",
        image:
          "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=80",
      },
      {
        title: "Downtown Rooftops",
        tag: "Nightlife",
        description: "High-rise dinner views, polished lounges, and the city in full glow.",
        image:
          "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?auto=format&fit=crop&w=900&q=80",
      },
    ],
    ctaRoute: { source: "Chennai", destination: "Dubai" },
  },
  {
    slug: "goa",
    city: "Goa",
    country: "India",
    heroEyebrow: "Discover India",
    heroTitle: "Goa.",
    heroDescription:
      "Coastal mornings, relaxed beach clubs, and a lighter pace built for quick decompression.",
    heroImage:
      "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?auto=format&fit=crop&w=1600&q=80",
    cardNote: "Weekend-ready from Bengaluru",
    cardTag: "Beach Escape",
    cardImage:
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1200&q=80",
    large: false,
    conciergeTitle: "A softer rhythm with just enough edge.",
    conciergeBody:
      "Goa is strongest when you resist overpacking it. Pick a side of the coast, leave breathing room between plans, and let the destination do more of the work for you.",
    highlights: [
      {
        key: "why-now",
        title: "Why Visit Now",
        body: "Short flying time, fast reset, and enough variety for both slow mornings and social nights.",
      },
      {
        key: "flyvora",
        title: "Flyvora Angle",
        body: "Ideal for quick couples' trips, friends' weekends, and last-minute sunny escapes.",
      },
    ],
    experiences: [
      {
        title: "North Goa Beach Clubs",
        tag: "Lifestyle",
        description: "Open-air lunches, ocean light, and a loose, playful energy.",
        image:
          "https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&w=1200&q=80",
        featured: true,
      },
      {
        title: "Fontainhas Walk",
        tag: "Culture",
        description: "Pastel streets, galleries, and a calmer heritage side of Goa.",
        image:
          "https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?auto=format&fit=crop&w=900&q=80",
      },
      {
        title: "Sunset by Chapora",
        tag: "Views",
        description: "A high-point stop for sea breeze, late light, and wide coastline views.",
        image:
          "https://images.unsplash.com/photo-1500375592092-40eb2168fd21?auto=format&fit=crop&w=900&q=80",
      },
      {
        title: "South Goa Retreats",
        tag: "Wellness",
        description: "Low-noise stays, long breakfasts, and quiet stretches of beach.",
        image:
          "https://images.unsplash.com/photo-1473116763249-2faaef81ccda?auto=format&fit=crop&w=900&q=80",
      },
    ],
    ctaRoute: { source: "Bengaluru", destination: "Goa" },
  },
  {
    slug: "mumbai",
    city: "Mumbai",
    country: "India",
    heroEyebrow: "Discover India",
    heroTitle: "Mumbai.",
    heroDescription:
      "Fast, cinematic, and full of texture, this is a destination for travelers who like their itineraries alive.",
    heroImage:
      "https://images.unsplash.com/photo-1567157577867-05ccb1388e66?auto=format&fit=crop&w=1600&q=80",
    cardNote: "City energy from Delhi",
    cardTag: "Urban Favorite",
    cardImage:
      "https://images.unsplash.com/photo-1595658658481-d53d3f999875?auto=format&fit=crop&w=1200&q=80",
    large: false,
    conciergeTitle: "A dense city that rewards sharp curation.",
    conciergeBody:
      "Mumbai lands best when the plan is intentional: one heritage stop, one sea-facing meal, one high-energy neighborhood, then space to let the city surprise you.",
    highlights: [
      {
        key: "why-now",
        title: "Why Visit Now",
        body: "Frequent departures, short lead times, and one of the easiest business-leisure blends in the network.",
      },
      {
        key: "flyvora",
        title: "Flyvora Angle",
        body: "Best for travelers who want momentum, polished hospitality, and easy premium urban stays.",
      },
    ],
    experiences: [
      {
        title: "Marine Drive at Golden Hour",
        tag: "Iconic",
        description: "The simplest and best way to recalibrate to the city.",
        image:
          "https://images.unsplash.com/photo-1570168007204-dfb528c6958f?auto=format&fit=crop&w=1200&q=80",
        featured: true,
      },
      {
        title: "Kala Ghoda Circuit",
        tag: "Culture",
        description: "Galleries, design stores, and heritage streets worth taking slowly.",
        image:
          "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=900&q=80",
      },
      {
        title: "Bandra Evenings",
        tag: "Dining",
        description: "Stylish restaurants, sea-link views, and a lighter side of the city.",
        image:
          "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?auto=format&fit=crop&w=900&q=80",
      },
      {
        title: "Gateway Waterfront",
        tag: "Landmark",
        description: "Classic city arrival energy with the harbor right in front of you.",
        image:
          "https://images.unsplash.com/photo-1513581166391-887a96ddeafd?auto=format&fit=crop&w=900&q=80",
      },
    ],
    ctaRoute: { source: "Delhi", destination: "Mumbai" },
  },
  {
    slug: "delhi",
    city: "Delhi",
    country: "India",
    heroEyebrow: "Discover India",
    heroTitle: "Delhi.",
    heroDescription:
      "Layered history, bold food, and capital-city scale brought together in one deeply textured stop.",
    heroImage:
      "https://images.unsplash.com/photo-1587474260584-136574528ed5?auto=format&fit=crop&w=1600&q=80",
    cardNote: "Capital return from Mumbai",
    cardTag: "Classic Circuit",
    cardImage:
      "https://images.unsplash.com/photo-1524499982521-1ffd58dd89ea?auto=format&fit=crop&w=1200&q=80",
    large: false,
    conciergeTitle: "A capital where contrast is the point.",
    conciergeBody:
      "Delhi is strongest when you let old and new sit next to each other: quiet morning monuments, a modern lunch, then a sharper neighborhood in the evening.",
    highlights: [
      {
        key: "why-now",
        title: "Why Visit Now",
        body: "Strong return connectivity, fast airport access, and enough variety for both business and culture-led travel.",
      },
      {
        key: "flyvora",
        title: "Flyvora Angle",
        body: "Ideal for travelers who want a serious city with heritage weight and modern comfort.",
      },
    ],
    experiences: [
      {
        title: "Humayun's Tomb Morning",
        tag: "Heritage",
        description: "A calmer architectural start before the city is fully awake.",
        image:
          "https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=1200&q=80",
        featured: true,
      },
      {
        title: "Lutyens' Drive",
        tag: "Cityscape",
        description: "Wide boulevards, diplomatic calm, and a very different Delhi rhythm.",
        image:
          "https://images.unsplash.com/photo-1577083552431-6e5fd75fcfb8?auto=format&fit=crop&w=900&q=80",
      },
      {
        title: "Khan Market Stops",
        tag: "Lifestyle",
        description: "Boutiques, bookstores, and polished lunch spots in one compact district.",
        image:
          "https://images.unsplash.com/photo-1517292987719-0369a794ec0f?auto=format&fit=crop&w=900&q=80",
      },
      {
        title: "Old Delhi Evenings",
        tag: "Food",
        description: "Dense, loud, and worth it for travelers who want the city at full volume.",
        image:
          "https://images.unsplash.com/photo-1513584684374-8bab748fbf90?auto=format&fit=crop&w=900&q=80",
      },
    ],
    ctaRoute: { source: "Mumbai", destination: "Delhi" },
  },
];

export const getFeaturedJourneyBySlug = (slug = "") =>
  featuredJourneys.find((journey) => journey.slug === slug);
